function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Close",
  transform: "translate(-6.586 -6.586)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_797",
  className: "all",
  "data-name": "Group 797",
  transform: "rotate(45 8 19.314)",
  fill: "none",
  stroke: "#98c3d9",
  strokeLinecap: "square",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  id: "Line_13",
  "data-name": "Line 13",
  transform: "translate(0 11.314)",
  d: "M0 0h22.627"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_14",
  "data-name": "Line 14",
  transform: "translate(11.314)",
  d: "M0 0v22.627"
})));

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.828,
    height: 18.828,
    viewBox: "0 0 18.828 18.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC44MjgiIGhlaWdodD0iMTguODI4IiB2aWV3Qm94PSIwIDAgMTguODI4IDE4LjgyOCI+CiAgPGcgaWQ9IkNsb3NlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNi41ODYgLTYuNTg2KSI+CiAgICA8ZyBpZD0iR3JvdXBfNzk3IiBjbGFzcz0iYWxsIiBkYXRhLW5hbWU9Ikdyb3VwIDc5NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYgMCkgcm90YXRlKDQ1KSI+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzEzIiBkYXRhLW5hbWU9IkxpbmUgMTMiIHgyPSIyMi42MjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTEuMzE0KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjOThjM2Q5IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfMTQiIGRhdGEtbmFtZT0iTGluZSAxNCIgeTI9IjIyLjYyNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMzE0IDApIiBmaWxsPSJub25lIiBzdHJva2U9IiM5OGMzZDkiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };